import { forwardRef, Ref } from 'react';
import { PropsWithForwardedRef } from '../../../types/types';
import { RadioSelect } from '../../Selection';
import { QuestionProps, RangeQuestionProps, ResponseValueType } from '../types';
import { getLabelText } from './getLabelText';
import { QuestionConditionals } from './QuestionConditionals';

type Props<TValue extends ResponseValueType = string> = QuestionProps<TValue> & RangeQuestionProps<TValue>;

const RangeQuestionWithRef = <TValue extends ResponseValueType = string>(
  { label, optional, value, conditionalMessages, supportingDocuments, ...radioSelectProps }: Props<TValue>,
  ref: Ref<HTMLInputElement | HTMLSelectElement>
) => {
  const labelText = getLabelText(label, optional);

  return (
    <>
      <RadioSelect<TValue> label={labelText} value={value} ref={ref} {...radioSelectProps} />

      <QuestionConditionals
        value={value}
        supportingDocuments={supportingDocuments}
        conditionalMessages={conditionalMessages}
      />
    </>
  );
};

export const RangeQuestion = forwardRef(RangeQuestionWithRef) as <TValue extends ResponseValueType = string>(
  props: PropsWithForwardedRef<Props<TValue>, HTMLInputElement | HTMLSelectElement>
) => ReturnType<typeof RangeQuestionWithRef>;
